/**
 * Baidu 自动推送（仅生产环境、显式开启时加载）。
 * 不影响 Google；与 hreflang / canonical 无冲突。
 */
export function initBaiduAutoPush() {
  if (process.env.NODE_ENV !== 'production') return;
  if (process.env.VUE_APP_BAIDU_AUTO_PUSH !== 'true') return;
  if (typeof document === 'undefined' || typeof window === 'undefined') return;

  const protocol = window.location.protocol.split(':')[0];
  const script = document.createElement('script');
  script.async = true;
  script.src =
    protocol === 'https'
      ? 'https://zz.bdstatic.com/linksubmit/push.js'
      : 'http://push.zhanzhang.baidu.com/push.js';
  const first = document.getElementsByTagName('script')[0];
  if (first && first.parentNode) {
    first.parentNode.insertBefore(script, first);
  } else {
    document.head.appendChild(script);
  }
}
